<template>
    <div class="ObjectListNoResult">
        <template v-if="globalFilter === filterTypes.liked">
            <div class="ObjectListNoResult__icon">
                <img src="@/assets/image/icons/noResult/no-result-liked.png" alt="liked">
            </div>
            <div class="ObjectListNoResult__text">
                В этом разделе будут сохранены ваши избранные объекты. Удобно, чтобы еще раз быстро посмотреть и решиться съездить на показ.
            </div>
        </template>
        <template v-else-if="globalFilter === filterTypes.disliked">
            <div class="ObjectListNoResult__icon">
                <img src="@/assets/image/icons/noResult/no-result-disliked.png" alt="disliked">
            </div>
            <div class="ObjectListNoResult__text">
                Здесь будут объекты, которые вам не понравились. Не бойтесь ставить дизлайк объектам.
                Поняв вашу реакцию, нам будет легче найти для вас идеальный дом.
            </div>
        </template>
        <template v-else>
            <div class="ObjectListNoResult__icon">
                <img src="@/assets/image/icons/noResult/no-result-shown.png" alt="shown">
            </div>
            <div class="ObjectListNoResult__text">
                Вы еще не были ни на одном показе
                <br>
                <br>
                Посмотрите актуальные предложения
                <br>
                и записывайтесь на показ.
            </div>
        </template>
        <Button @click="setGlobalFilter(null)" :transparent="true">Смотреть предложения</Button>
    </div>
</template>

<script>
import filterTypes from "@/constants/filterTypes";
import Button from "@/components/elements/Button";
import {mapMutations, mapState} from "vuex";

export default {
    name: "ObjectListNoResult",
    components: {
        Button,
    },
    data: () => ({
        filterTypes
    }),
    computed: {
        ...mapState(['globalFilter'])
    },
    methods: {
        ...mapMutations(['setGlobalFilter'])
    }
}
</script>

<style lang="scss">
.ObjectListNoResult {
  padding: 100px 0;
  max-width: 450px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  &__icon {
    margin-bottom: 40px;
  }

  &__text {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 40px;
  }
}
</style>